/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryRecipeValidationData
 */
export interface GoogleBigQueryRecipeValidationData {
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeValidationData
     */
    recipeName?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryRecipeValidationData
     */
    recipeVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeValidationData
     */
    estimatedBytesProcessed?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeValidationData
     */
    location?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleBigQueryRecipeValidationData
     */
    schemaCompatible?: boolean;
    /**
     * 
     * @type {GoogleBigQueryRecipeValidationDataStatusEnum}
     * @memberof GoogleBigQueryRecipeValidationData
     */
    status?: GoogleBigQueryRecipeValidationDataStatusEnum;
}


/**
 * @export
 */
export const GoogleBigQueryRecipeValidationDataStatusEnum = {
    PendingEventsExport: 'pending-events-export',
    Ready: 'ready'
} as const;
export type GoogleBigQueryRecipeValidationDataStatusEnum = typeof GoogleBigQueryRecipeValidationDataStatusEnum[keyof typeof GoogleBigQueryRecipeValidationDataStatusEnum];


/**
 * Check if a given object implements the GoogleBigQueryRecipeValidationData interface.
 */
export function instanceOfGoogleBigQueryRecipeValidationData(value: object): value is GoogleBigQueryRecipeValidationData {
    return true;
}

export function GoogleBigQueryRecipeValidationDataFromJSON(json: any): GoogleBigQueryRecipeValidationData {
    return GoogleBigQueryRecipeValidationDataFromJSONTyped(json, false);
}

export function GoogleBigQueryRecipeValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryRecipeValidationData {
    if (json == null) {
        return json;
    }
    return {
        
        'recipeName': json['recipeName'] == null ? undefined : json['recipeName'],
        'recipeVersion': json['recipeVersion'] == null ? undefined : json['recipeVersion'],
        'estimatedBytesProcessed': json['estimatedBytesProcessed'] === undefined ? undefined : json['estimatedBytesProcessed'] === null ? null : json['estimatedBytesProcessed'],
        'location': json['location'] == null ? undefined : json['location'],
        'schemaCompatible': json['schemaCompatible'] == null ? undefined : json['schemaCompatible'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function GoogleBigQueryRecipeValidationDataToJSON(json: any): GoogleBigQueryRecipeValidationData {
    return GoogleBigQueryRecipeValidationDataToJSONTyped(json, false);
}

export function GoogleBigQueryRecipeValidationDataToJSONTyped(value?: GoogleBigQueryRecipeValidationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipeName': value['recipeName'],
        'recipeVersion': value['recipeVersion'],
        'estimatedBytesProcessed': value['estimatedBytesProcessed'],
        'location': value['location'],
        'schemaCompatible': value['schemaCompatible'],
        'status': value['status'],
    };
}

